import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import SceneContainer from "Containers/Scene";
import { areEqualShallow } from "Utils/areEqual";
import DirectionsAndPopUps from "Containers/DirectionsAndPopUps";
import styles from "./styles";

interface Props {
  currentStop: number;
  mapObj: any;
  locId: any;
}

const Map: FC<Props> = memo(({ currentStop, mapObj, locId }: Props) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles();
  return (
    <div
      className={classes.mapContainer}
      id="campusMap"
      data-testid="campusmap"
    >
      <DirectionsAndPopUps mapObj={mapObj} />
      {currentStop !== -1 && (
        <SceneContainer
          currentStop={currentStop}
          locId={locId}
          mapObj={mapObj}
        />
      )}
    </div>
  );
}, areEqualShallow);
export default Map;
try {
    // @ts-ignore
    Map.displayName = "Map";
    // @ts-ignore
    Map.__docgenInfo = { "description": "", "displayName": "Map", "props": { "currentStop": { "defaultValue": null, "description": "", "name": "currentStop", "required": true, "type": { "name": "number" } }, "mapObj": { "defaultValue": null, "description": "", "name": "mapObj", "required": true, "type": { "name": "any" } }, "locId": { "defaultValue": null, "description": "", "name": "locId", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Map/Map.tsx#Map"] = { docgenInfo: Map.__docgenInfo, name: "Map", path: "src/shared/components/Map/Map.tsx#Map" };
}
catch (__react_docgen_typescript_loader_error) { }